import React, { lazy, ReactElement, Suspense } from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import * as serviceWorker from './serviceWorker'
import { MobileMode, MobileThemeProvider, ThemeProvider } from '@amzn/storm-ui'
import { BrowserRouter } from 'react-router-dom'
import { Routes } from './routes'
import './i18n'
import { CrowdSurfApolloProvider, isA20MEndPoint } from './util/CrowdSurfApolloProvider'
import { overrideTheme } from './shared/theme/override_theme'
import { MOBILE_SETUP } from '@amzn/aapn-react-components'
import { CrowdSurfConfigCodec, CrowdSurfConfigContext } from 'util/appconfig'
import { GlobalErrorBoundary } from './shared/components/global_error_boundary/global_error_boundary'
import { ConfigBuilder } from './util/config_builder'
import { JamSessionProvider } from './util/jamsession/provider/jamsession_provider'

const LoginCheck = lazy(() => import('@amzn/aapn-front-end-login-lib').then(module => ({ default: module.LoginCheck })))

const ApolloProvider: React.FunctionComponent = (): ReactElement => {
  return (
    <CrowdSurfApolloProvider>
      <GlobalErrorBoundary>
        <JamSessionProvider principal={''}>
          <Routes />
        </JamSessionProvider>
      </GlobalErrorBoundary>
    </CrowdSurfApolloProvider>
  )
}

const Site: React.FunctionComponent = (): ReactElement => {
  const hostname = window?.location?.hostname
  return (
    <ThemeProvider theme={overrideTheme(MOBILE_SETUP)}>
      <Suspense fallback={<React.Fragment />}>
        <BrowserRouter>
          <ConfigBuilder codec={CrowdSurfConfigCodec} context={CrowdSurfConfigContext}>
            <MobileThemeProvider mobileMode={MobileMode.Auto}>
              {isA20MEndPoint(hostname) ? (
                <ApolloProvider />
              ) : (
                <LoginCheck>
                  <ApolloProvider />
                </LoginCheck>
              )}
            </MobileThemeProvider>
          </ConfigBuilder>
        </BrowserRouter>
      </Suspense>
    </ThemeProvider>
  )
}

const handler = (event: ProgressEvent<Document>): void => {
  const readyState = event?.target?.readyState
  if (readyState === 'interactive' || readyState === 'complete') {
    ReactDOM.render(<Site />, document.getElementById('root'))
    document.removeEventListener('readystatechange', handler as (e: Event) => void)
  }
}

if (document.readyState === 'interactive' || document.readyState === 'complete') {
  ReactDOM.render(<Site />, document.getElementById('root'))
} else {
  document.addEventListener('readystatechange', handler as (e: Event) => void)
}

if (process.env.NODE_ENV !== 'production') {
  import('@axe-core/react').then(({ default: axe }) => {
    axe(React, ReactDOM, 3000)
  })
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
